import { makeStyles } from '@material-ui/core/styles';

export const useFormCustomPageStyles = makeStyles(theme => ({
  formField: {
    flexGrow: 1
  }
}));
